export type HelpPortalMode = "local" | "freshdesk" | "chatwoot";

function normalizeHelpPortalMode(value: string | undefined): HelpPortalMode {
  const normalized = String(value || "")
    .trim()
    .toLowerCase();
  if (normalized === "freshdesk") return "freshdesk";
  if (normalized === "chatwoot") return "chatwoot";
  return "local";
}

// Single source of truth for which help/support portal the frontend should prefer.
// `freshdesk` enables the Freshdesk KB/chat surfaces;
// `chatwoot` enables the self-hosted Chatwoot live chat;
// `local` keeps support fully in-app.
export const HELP_PORTAL_MODE: HelpPortalMode = normalizeHelpPortalMode(
  import.meta.env.VITE_HELP_PORTAL_MODE,
);

export function prefersFreshdeskHelpPortal(): boolean {
  return HELP_PORTAL_MODE === "freshdesk";
}

export function prefersChatwootPortal(): boolean {
  return HELP_PORTAL_MODE === "chatwoot";
}
